export  default {
    getSystemSites(state) {
        return state.systemSites;
    } 
};